/**
 * Adds notes data to steps that have a workflow_note
 */
export const renderNotes = data => {
  for (const note of data.notes) {
    const node = data.nodes.find(
      n => n.type == note.step_type && n.type_id == note.step_id
    )
    if (!node) continue

    const notesButton = node.element.find("button[data-notes]")
    if (!notesButton) continue

    notesButton.dataset.noteId = note.id
    notesButton.dataset.noteBody = note.body || ""
  }

  return data
}

